import { useNavigate } from 'react-router-dom';

import { ContentThumbnail } from './ContentThumbnail';

interface SharedFolderThumbnailProps {
  fromRecord: {
    content_type: string;
    extension: string;
    file_type: string;
    id: number;
    name: string;
    shared_from: string;
    shared_url: string;
    thumbnail_url: string;
    type: string;
    url: string;
  };
}

const SharedFolderThumbnail = ({ fromRecord }: SharedFolderThumbnailProps) => {
  const navigate = useNavigate();

  return (
    <ContentThumbnail
      content={{
        url: fromRecord.url,
        name: fromRecord.name,
        content_type: fromRecord.content_type,
        file_type: fromRecord.file_type,
        thumbnail_url: fromRecord.thumbnail_url,
        cover_picture_file_url: fromRecord.thumbnail_url,
        type: fromRecord.type,
        extension: fromRecord.extension,
      }}
      sharedFrom={fromRecord.shared_from}
      sharedUrl={fromRecord.shared_url}
      onClick={() => navigate(fromRecord.shared_url)}
    />
  );
};

export default SharedFolderThumbnail;
